'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.set = set;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET = 'i18n/SET';

var initialState = {
  loaded: false
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET:
      return (0, _extends3.default)({}, state, action.i18n, {
        lang: action.lang,
        loaded: action.loaded
      });
    default:
      return state;
  }
}

function set(lang, _i18n, loaded) {
  return {
    lang: lang,
    type: SET,
    i18n: _i18n,
    loaded: loaded
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/trv-fed-modules-i18n.js
// module id = 1252
// module chunks = 0